export const SET_LIVE_LOCATION = 'SET_LIVE_LOCATION';
export const CHANGE_STATE_SPEED = 'CHANGE_STATE_SPEED';
